'use client'

import React, { useEffect } from "react";
import { UserContextProvider } from "./useUserContext";
import { NotificationProvider } from "@/components/PushNotification/NotificationProvider";
import { ChatProvider } from "@/components/Chat/ChatProvider";

export const AppProviders = ({ children }: { children: React.ReactNode }) => {
  return (
      <UserContextProvider>
        <NotificationProvider>
          <ChatProvider>
            {children}
          </ChatProvider>
        </NotificationProvider>
      </UserContextProvider>
  );
};
